// extracted by mini-css-extract-plugin
export default {"inner":"columnsFilter_inner__qQFIF","popover":"columnsFilter_popover__Yup9E"};